/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import './AddressDisplayView.css';
import tmplAddressDisplayView from './AddressDisplayView.hbs';

const AddressDisplayView = View.extend({
  template: tmplAddressDisplayView,

  templateContext() {
    const hasAddress =
      this.model.get('addressLine1') ||
      this.model.get('addressLine2') ||
      this.model.get('addressLine3') ||
      this.model.get('city');
    return {
      hasAddress,
      showCounty: this.options.showCounty,
    };
  },

  className() {
    const classesOption = this.options.classes;
    const classNameBase = 'address-display-view';
    return classesOption ? classNameBase : `${classNameBase} ${classesOption}`;
  },
});

export default AddressDisplayView;
